module.exports = __webpack_public_path__ + "static/media/azotu.91e728ef.jpg";